var _filter, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPursesMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 49,
    viewBox: "0 0 49 49",
    width: 49,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 49,
    width: 49,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.468733 0 0 0 0 0.51145 0 0 0 0 0.554167 0 0 0 0.39 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_6701_12"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6701_12",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    fill: "#fff",
    r: 20.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.3298 10c-.7299 0-1.4286.2797-1.9279.7864-.07.0709-.1155.1618-.13.2597-.0144.0978.0029.1977.0495.2853l1.5013 3.5179c-.4717.3247-.7823.861-.7823 1.4662 0 .3245.0889.6293.2445.8929-3.7523 2.3762-6.2849 7.3911-6.2849 11.3109 0 5.2533 4.7309 9.4807 10.5019 9.4807s10.4981-4.2274 10.4981-9.4807c0-3.9207-2.5315-8.9362-6.2849-11.3118.1548-.2635.2445-.5678.2445-.892 0-.6049-.3091-1.1414-.7794-1.4662l1.4974-3.5113c.0487-.088.0676-.189.0538-.2882s-.0595-.1915-.1305-.2634c-.4992-.5067-1.1979-.7864-1.9278-.7864s-1.4315.2797-1.9307.7864c-.3107.3154-.7619.5026-1.2405.5026-.4706 0-.9187-.1806-1.229-.4866-.0049-.0054-.0101-.0108-.0153-.016-.4992-.5068-1.198-.7864-1.9278-.7864zm0 .9391c.4786 0 .9335.1872 1.2443.5026.4992.5067 1.1979.7873 1.9278.7873s1.4276-.2806 1.9269-.7873c.0052-.0052.0103-.0106.0153-.0161.3103-.3059.7584-.4865 1.229-.4865.3696 0 .7227.1123 1.0075.3083l-1.4005 3.2822c-.0482-.0038-.0966-.0065-.1458-.0065h-5.2658c-.0491 0-.0975.0027-.1457.0065l-1.4034-3.2802c.2853-.1973.6396-.3103 1.0104-.3103zm.5387 4.5231h5.2658c.4922 0 .8734.3714.8734.8533s-.3812.8561-.8734.8561h-5.2658c-.4921 0-.8733-.3742-.8733-.8561s.3812-.8533.8733-.8533zm-.8829 2.4222c.2626.1437.5633.2263.8829.2263h5.2658c.3199 0 .6207-.0824.883-.2263 3.4754 2.099 6.0279 7.0676 6.0279 10.6349 0 4.698-4.2439 8.5406-9.5433 8.5406s-9.5471-3.8426-9.5471-8.5406c0-3.5673 2.5553-8.5359 6.0308-10.6349zm3.5163 3.9941c-.063-.0002-.1254.0118-.1837.0354s-.1112.0583-.1558.1021c-.0445.0439-.0798.0959-.1038.1533-.024.0573-.0363.1187-.036.1807v.8929c-1.2978.1988-2.3295 1.1911-2.3295 2.4383 0 1.3973 1.2956 2.4741 2.8088 2.4741 1.0623 0 1.8531.7156 1.8531 1.5322s-.7908 1.536-1.8531 1.536c-.9273 0-1.6766-.565-1.8262-1.2692-.0128-.0606-.0376-.1182-.0731-.1693-.0355-.0512-.0809-.095-.1336-.1288-.0528-.0338-.1118-.0571-.1737-.0684-.062-.0113-.1255-.0104-.1871.0026-.124.0254-.2326.0982-.302.2023-.0693.1042-.0938.2311-.068.3531.2238 1.0533 1.1626 1.8111 2.2844 1.981v.8957c.0002.0617.0128.1227.0371.1795.0242.0569.0596.1086.1041.152s.0973.0778.1553.1012c.058.0233.1201.0352.1828.035.126-.0005.2466-.05.3357-.1376.089-.0876.1393-.2062.1398-.3301v-.8957c1.2992-.1978 2.3324-1.1911 2.3324-2.4393 0-1.3973-1.2947-2.4713-2.8079-2.4713-1.0622 0-1.854-.7184-1.854-1.535s.7918-1.536 1.854-1.536c.9274 0 1.6756.5678 1.8253 1.272.0258.1217.0996.2283.2053.2966.1057.0682.2345.0924.3584.0673.0616-.0125.1201-.037.1722-.0719.052-.0349.0965-.0795.1309-.1314s.058-.11.0695-.1709.0106-.1234-.0026-.184c-.224-1.0542-1.1611-1.8119-2.2835-1.981v-.8919c.0003-.0617-.0118-.1228-.0356-.1799-.0238-.057-.0587-.1089-.1029-.1527-.0441-.0438-.0966-.0786-.1544-.1024-.0579-.0238-.1199-.0362-.1826-.0365z",
    fill: "#6a7988",
    stroke: "#6a7988",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPursesMoney);
export default __webpack_public_path__ + "static/media/purses-money.c5eb6bdaff1f397574b224918af140ed.svg";
export { ForwardRef as ReactComponent };